import React, {Fragment} from 'react';
import PageTitle from '../../../../Layout/AppMain/PageTitle';
import Tabs from 'react-responsive-tabs';
import Cordon from './component/Cordon';



const tabsContent = [
    {
        title: 'Cordón Arteroides',
        content: <Cordon/>
    }
];



function getTabs() {
    return tabsContent.map((tab, index) => ({
        title: tab.title,
        getContent: () => tab.content,
        key: index,
    }));
}

export default class CordonElementosComponent extends React.Component {

    render() {

        return (
            <Fragment>
                <PageTitle
                    heading="Elementos del  Juego: Cordón Arteroides"
                    subheading=""
                    icon="lnr-graduation-hat icon-gradient bg-mean-fruit"
                />
                <Tabs tabsWrapperClass="body-tabs body-tabs-layout" transform={false} showInkBar={true} items={getTabs()}/>
               
            </Fragment>
        );
    }
}


// WEBPACK FOOTER //
// src/Pages/ObjetivosDelJuego/elementosDelJuego/Cordon-admin/index.js